// extracted by mini-css-extract-plugin
export var bottomrow = "IntroOurCentres-module--bottomrow--8f5ec";
export var columnscurvedborder = "IntroOurCentres-module--columnscurvedborder--135c4";
export var columnscurvedborderwrapper = "IntroOurCentres-module--columnscurvedborderwrapper--af0f4";
export var introcolumninner = "IntroOurCentres-module--introcolumninner--1aa87";
export var introcolumnouter = "IntroOurCentres-module--introcolumnouter--42bb0";
export var introcolumnouterdesktop = "IntroOurCentres-module--introcolumnouterdesktop--c2565 IntroOurCentres-module--introcolumnouter--42bb0";
export var introcolumnoutermobile = "IntroOurCentres-module--introcolumnoutermobile--08d14 IntroOurCentres-module--introcolumnouter--42bb0";
export var leftcolumn = "IntroOurCentres-module--leftcolumn--44efa";
export var rightcolumn = "IntroOurCentres-module--rightcolumn--29b2a";
export var rowscurvedborder = "IntroOurCentres-module--rowscurvedborder--f3849";
export var text = "IntroOurCentres-module--text--2c5b6";
export var toprow = "IntroOurCentres-module--toprow--7214d";
export var twocolumncontent = "IntroOurCentres-module--twocolumncontent--a9d91";
export var tworowcontent = "IntroOurCentres-module--tworowcontent--7a70d";